var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin"},[_c('sidebar',{class:_vm.sidebarClasses,on:{"navigate":_vm.closeSidebar}}),_c('container',{staticClass:"admin__content",nativeOn:{"click":function($event){return _vm.closeSidebar($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }